module.exports = __webpack_public_path__ + "4e575a40ae8c60f16c7ce4e104d6e79a.jpg";